import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import Headers from "../../Components/HeaderPublic";
import Footer from "../../Components/Footer";

function ContactSuccess() {
  const location = useLocation();
  const { nombre, email, mensaje } = location.state || {
    nombre: "Usuario",
    email: "",
    mensaje: "Gracias por contactarnos",
  };

  // Asegurar que la página se cargue desde la parte superior
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Estilo CSS para forzar full width en header y footer
  const fullWidthStyle = {
    width: "100vw",
    position: "relative",
    left: "50%",
    right: "50%",
    marginLeft: "-50vw",
    marginRight: "-50vw",
    overflowX: "hidden",
  };

  return (
    <>
      {/* Header de ancho completo */}
      <div style={fullWidthStyle}>
        <Headers />
      </div>

      {/* Contenido principal */}
      <div className="min-h-[70vh] flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md  mt-8 w-full space-y-8 bg-white p-10 rounded-xl shadow-lg">
          <div>
            <div className="flex   justify-center">
              <div className="rounded-full bg-green-100 p-4">
                <svg
                  className="h-12 w-12 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>
            </div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              ¡Mensaje enviado con éxito!
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Gracias {nombre} por comunicarte con nosotros
            </p>

            <div className="mt-8 bg-gray-50 p-4 rounded-lg border border-gray-200">
              <p className="text-sm text-gray-700">
                Hemos recibido tu mensaje y nos pondremos en contacto contigo a
                la brevedad posible.
              </p>
              {email && (
                <p className="text-sm text-gray-700 mt-2">
                  Te enviaremos nuestra respuesta al correo:{" "}
                  <strong>{email}</strong>
                </p>
              )}
            </div>
          </div>

          <div className="mt-8 flex justify-center">
            <Link
              to="/"
              className="group relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-800 hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Volver a la página principal
            </Link>
          </div>
        </div>
      </div>

      {/* Footer de ancho completo */}
      <div style={fullWidthStyle} className="-mb-8">
        <Footer />
      </div>
    </>
  );
}

export default ContactSuccess;
